import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";
import "./adrList.css";

class AdrPreview extends Component {
  render() {
    const { adr, previewData, renderAdrStatus } = this.props;
    return (
      <div className="card flex-grow-1 adrlist-preview-container">
        <div className="card-header bg-lightgray">Daily Report Info</div>
        <div className="card-body">
          {adr ? (
            <React.Fragment>
              <span>
                <small>Written By:</small>
              </span>
              <h4>{adr.authorFullName}</h4>
              <h5 className="text-muted mb-1">
                {moment(adr.reportStartDate).format("MM/DD/YYYY")}; Rpt No: {adr.reportNo}
              </h5>
              <span className="text-muted">
                <b>Subcategory: </b>
                {adr.customCategory || "(None)"}
              </span>
              <br />
              {renderAdrStatus(adr)}
              <hr className="my-2 hr-thick" />
              <span>
                <b>Locations:</b>
              </span>
              {previewData && (
                <div className="list-group-flush pl-0 border-top mb-2">
                  {previewData.locPreview ? (
                    previewData.locPreview.map((lp, index) => (
                      <li key={`lpKey_${index}`} className="list-group-item py-1 pl-1">
                        {lp}
                      </li>
                    ))
                  ) : (
                    <li className="list-group-item py-1 pl-1">(None)</li>
                  )}
                </div>
              )}
              <span>
                <b>Work Performed:</b>
              </span>
              {previewData && (
                <div className="list-group-flush pl-0 border-top mb-2">
                  {previewData.wpPreview ? (
                    previewData.wpPreview.map((wpp, index) => (
                      <li key={`wppIndex_${index}`} className="list-group-item py-1 pl-1">
                        {wpp}
                      </li>
                    ))
                  ) : (
                    <li className="list-group-item py-1 pl-1">(None)</li>
                  )}
                </div>
              )}
              <span>
                <b>Document History:</b>
              </span>
              {adr.history && (
                <ul className="list-group-flush pl-0 border-bottom">
                  <li className="list-group-item pl-0 py-0 bg-lightgray">
                    <div className="row">
                      <div className="col pr-1 pl-4">
                        <small>
                          <b>Action</b>
                        </small>
                      </div>
                      <div className="col pl-1">
                        <small>
                          <b>Timestamp</b>
                        </small>
                      </div>
                    </div>
                  </li>
                  {adr.history.length > 0 ? (
                    _.orderBy(adr.history, "statusDate", "desc").map((h, index) => (
                      <li
                        key={`adrHistoryPreviewIndex_${index}`}
                        className="list-group-item pl-0 py-0"
                      >
                        <div className="row">
                          <div className="col pr-1 pl-4">
                            <small>{h.status}</small>
                          </div>
                          <div className="col pl-1">
                            <small>{moment(h.statusDate).format("L LT")}</small>
                          </div>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="list-group-item pl-0 py-0">
                      <div className="row">
                        <div className="col pl-4">(N/A)</div>
                      </div>
                    </li>
                  )}
                </ul>
              )}
            </React.Fragment>
          ) : (
            <h5 className="text-muted">No Daily Report selected</h5>
          )}
        </div>
      </div>
    );
  }
}

export default AdrPreview;
